import { PointLight } from "three";
import { useGLTF } from "@react-three/drei";
import React, { useRef, useState } from "react";
import { useFrame, useLoader } from "@react-three/fiber";
import * as THREE from "three";
import { captainObject } from "../../interface";
import { HoverText } from "../../HoverText";

export const Captain = ({
  id,
  url,
  remove,
  speed,
  scale,
  position,
  direction,
  getCharacters,
}: captainObject) => {
  const { scene } = useGLTF(url, "/draco/");
  const captainRef = useRef<any>();
  const pngRef = useRef<any>();
  const pngRef2 = useRef<any>();
  const textRef = useRef<any>();
  const lightRef = useRef<PointLight>(null!);
  const [hovered, setHovered] = useState(false);
  let angle = useRef(Math.PI); // 当前的旋转角度
  let totalRotation = useRef(0); // 跟踪总旋转角度

  // 设置旋转半径和初始角度
  const radius = 3.3;

  // 鼠标移入时显示光源和文本
  const handlePointerOver = () => {
    setHovered(true);
    if (textRef.current) {
      textRef.current.visible = true;
    }
  };

  // 鼠标移出时隐藏光源和文本
  const handlePointerOut = () => {
    setHovered(false);
    if (textRef.current) {
      textRef.current.visible = false;
    }
  };

  useFrame((state, delta) => {
    if (captainRef.current) {
      if (!hovered) {
        // 旋转火箭
        const deltaAngle = speed * delta * (direction ? 1 : -1); // 根据顺时针或逆时针旋转
        angle.current += deltaAngle;

        // 累积总旋转角度的绝对值
        totalRotation.current += Math.abs(deltaAngle);

        // 设置火箭位置
        const x = radius * Math.sin(angle.current);
        const z = radius * Math.cos(angle.current);
        captainRef.current.position.set(x, 0, z);

        // 让火箭始终面向地球
        captainRef.current.lookAt(0, 0, 0);

        // 调整火箭头指向当前的旋转方向
        if (direction) {
          captainRef.current.rotateOnAxis(
            new THREE.Vector3(0, 1, 0),
            -Math.PI / 2,
          );
        }
      }
      const { x, y, z } = captainRef.current.position;

      if (lightRef.current) {
        lightRef.current.position.set(x, y + 0.6, z + 0.5);
      }

      if (textRef.current) {
        textRef.current.position.set(x + 0.3, y - 0.8, z - 0.2);
      }

      // 检查火箭是否已经旋转了360度
      if (totalRotation.current >= Math.PI * 2) {
        remove(id);
      }
    }
  });

  return (
    <>
      <primitive
        ref={captainRef}
        object={scene}
        position={position.toArray()}
        rotation={[0, 5, 0]}
        scale={scale}
        onClick={() => getCharacters("captain")}
        onPointerOver={handlePointerOver}
        onPointerOut={handlePointerOut}
      />
      {hovered && (
        <>
          <pointLight ref={lightRef} intensity={1} color={"#ffcc00"} />
        </>
      )}
      <HoverText text={"Orbit"} color={"#FFD700"} textRef={textRef} />
    </>
  );
};
